import React from "react";
import { injectIntl } from "gatsby-plugin-intl";
import Layout from "../../components/Layout";
import DownloadPage from "../../components/DownloadPage";

const StartPage = ({ intl }) => {
  return (
    <Layout>
      <DownloadPage
        type="portable"
        text={intl.formatMessage({ id: "text_download_thankyou" })}
      />
    </Layout>
  );
};

export default injectIntl(StartPage);
